function getImageUrl(source: string) {
  if (source?.includes('undefined') || !source) {
    return require('../../../assets/src/images/logo.png');
  } else {
    return {
      uri: `https://messenger.holding5040.ir/user/getUserAvatar/${source}`,
      // uri: `http://192.168.121.199:5000/user/getUserAvatar/${source}`,
    };
  }
}
export { getImageUrl };
